import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, BrainCircuit } from 'lucide-react';
export function ContextEngineeringHero() {
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  return <section className="relative w-full pt-0 pb-24 px-6 md:px-12 lg:px-24 bg-white overflow-hidden" data-id="element-495">
      <div className="max-w-7xl mx-auto" data-id="element-496">
        <div className="h-px bg-gray-200 w-full mb-12" data-id="element-497"></div>

        <div className="grid grid-cols-1 lg:grid-cols-[1fr_450px] gap-16 lg:gap-24 items-center" data-id="element-498">
          <div data-id="element-499">
            <h1 className="text-3xl md:text-4xl font-bold font-['Syne'] text-black mb-8 leading-tight" data-id="element-500">
              AI makes Invisible decisions <br data-id="element-501" />
              when instructions are incomplete
            </h1>

            <p className="text-lg text-gray-700 leading-relaxed mb-6" data-id="element-502">
              No prompt can be "engineered" to capture everything that matters:
            </p>

            <ul className="space-y-2 mb-10 list-disc list-inside text-gray-600" data-id="element-503">
              <li className="leading-snug" data-id="element-504">
                What part of this information is actually relevant?
              </li>
              <li className="leading-snug" data-id="element-505">
                What's my role, and how does that change what's appropriate?
              </li>
              <li className="leading-snug" data-id="element-506">Is this high-risk or low-risk?</li>
              <li className="leading-snug" data-id="element-507">
                Should I optimize for speed, completeness, or caution?
              </li>
              <li className="leading-snug" data-id="element-508">Which regulations apply—if any?</li>
              <li className="leading-snug" data-id="element-509">
                What terminology is acceptable vs. prohibited?
              </li>
              <li className="leading-snug" data-id="element-510">
                Should I escalate uncertainty or resolve it myself?
              </li>
            </ul>

            <p className="text-lg text-gray-700 leading-relaxed mb-10 font-medium" data-id="element-511">
              Synthia provides the instructions AI needs to answer these
              questions correctly—using your institutional intelligence, not
              internet averages.
            </p>

            <Link to="/contact" onClick={scrollToTop} className="flex items-center gap-2 px-8 py-4 bg-[#0066FF] text-white font-['Syne'] font-bold text-sm tracking-wide uppercase hover:bg-black transition-all duration-200 hover:scale-105 w-fit" data-id="element-512">
              BOOK A DEMO
              <ArrowRight className="w-5 h-5" data-id="element-513" />
            </Link>
          </div>

          <div className="bg-gray-50 rounded-2xl p-10 md:p-12 border border-gray-100 relative" data-id="element-514">
            <div className="absolute top-0 right-0 -mt-4 -mr-4 bg-[#0066FF] text-white p-4 rounded-full shadow-lg hidden md:block" data-id="element-515">
              <BrainCircuit className="w-8 h-8" data-id="element-516" />
            </div>
            <h2 className="text-2xl md:text-3xl font-bold font-['Syne'] text-black mb-6" data-id="element-517">
              The problem isn't the model. <br data-id="element-518" />
              <span className="text-[#0066FF]" data-id="element-519">It's the context.</span>
            </h2>
            <p className="text-base md:text-lg text-gray-600 leading-relaxed mb-8" data-id="element-520">
              Context is the gap between AI outputs you fix and AI outputs you
              ship.
            </p>
            <p className="text-base md:text-lg text-gray-600 leading-relaxed mb-8" data-id="element-521">
              Context engineering captures your institutional
              intelligence—compliance rules, quality standards, expert
              judgment—and enforces it automatically. Build it once. Deploy it
              everywhere.
            </p>
          </div>
        </div>
      </div>
    </section>;
}